import {Component, EventEmitter, Output} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {NgIf} from "@angular/common";

export interface ConnectionModeForm {
  mode: 'cabinet' | 'maisonMedicale' | 'pmg' | '';
  is1733: boolean;
}

@Component({
  selector: 'ms-form-connection-mode',
  standalone: true,
  imports: [FormsModule, NgIf],
  templateUrl: './form-connection-mode.component.html',
  styleUrl: './form-connection-mode.component.scss'
})
export class FormConnectionModeComponent {

  @Output() formChange = new EventEmitter<ConnectionModeForm>();

  public form: ConnectionModeForm = {
    mode: '',
    is1733: false,
  };

  public onModeChange() {
    if (this.form.mode !== 'pmg') {
      this.form = {...this.form, is1733: false};
    }
    this.formChange.emit({...this.form});
  }

  public onFieldChange() {
    this.formChange.emit({...this.form});
  }
}
